import React from "react";
import ojo_img from "./images/ojo.svg";
import cuaderno_img from "./images/cuaderno.svg";
import {getMessage} from "./util";

const SaberMas =(props)=> {

        return (
            <div className="row justify-content-center sabermas EvColorBlue text-white">
                <div className=" col-12 col-md-6 text-center sabermas-box d-flex justify-content-center align-items-center">
                    <h3 className="font-weight-bold">{getMessage("saber_mas_titulo_1", props.messages)}
                        <br/>{getMessage("saber_mas_titulo_2", props.messages)}
                        <br/>{getMessage("saber_mas_titulo_3", props.messages)}</h3>

                    <div><span className="linespanwhite mb-4"></span></div>
                </div>
                <div className="col-12 col-md-6 text-center h5 ">
                    <div className="row">
                        <div className="col-6">
                            <a href={props.election.configuration.bulletin_url.replace(/%s/g, props.election._id_first)}><img
                                src={ojo_img} className="img-max-100" alt="Participación"/>
                                <p className="font-weight-bold no-decoration">Revisar la<br/> participación</p>
                            </a>
                        </div>
                        <div className="col-6">
                            <a href={props.election.configuration.ballot_box_url + '/election_comments/' + props.election._id_first + '/new'}>
                                <img src={cuaderno_img} className="img-max-100" alt="Registrar Observación"/>
                                <p className="font-weight-bold no-decoration">Registrar una observación<br/> en el libro
                                </p>
                            </a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <a href={props.election.configuration.bulletin_url.replace(/%s/g, props.election._id_second)}><img
                                src={ojo_img} className="img-max-100" alt="Participación"/>
                                <p className="font-weight-bold no-decoration">Revisar la<br/> participación Sede San Bernardo / Puente Alto / Maipú</p>
                            </a>
                        </div>
                        <div className="col-6">
                            <a href={props.election.configuration.ballot_box_url + '/election_comments/' + props.election._id_second + '/new'}>
                                <img src={cuaderno_img} className="img-max-100" alt="Registrar Observación"/>
                                <p className="font-weight-bold no-decoration">Registrar una observación<br/> en el libro Sede San Bernardo / Puente Alto / Maipú
                                </p>
                            </a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <a href={props.election.configuration.bulletin_url.replace(/%s/g, props.election._id_third)}><img
                                src={ojo_img} className="img-max-100" alt="Participación"/>
                                <p className="font-weight-bold no-decoration">Revisar la<br/> participación Sede Plaza Oeste Ingeniería en Gestión Logística / Técnico en Gestión Logística</p>
                            </a>
                        </div>
                        <div className="col-6">
                            <a href={props.election.configuration.ballot_box_url + '/election_comments/' + props.election._id_third + '/new'}>
                                <img src={cuaderno_img} className="img-max-100" alt="Registrar Observación"/>
                                <p className="font-weight-bold no-decoration">Registrar una observación<br/> en el libroSede Plaza Oeste Ingeniería en Gestión Logística / Técnico en Gestión Logística
                                </p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        );
    }


export default SaberMas;